export default __webpack_public_path__ + "static/media/coin.015e6026.png";